import { useScrollDriven, pageProgress } from '../../hooks/useScrollDriven';

const progressVars = (y: number, vh: number) => ({ '--sp': pageProgress(y, vh).toFixed(4) });

export const ScrollProgress = () => {
  const ref = useScrollDriven<HTMLDivElement>(progressVars);
  return (
    <div
      ref={ref}
      aria-hidden="true"
      className="fixed top-0 left-0 right-0 h-[2px] bg-timber z-[100] origin-left transition-transform duration-100 ease-out"
      style={{ transform: 'scaleX(var(--sp, 0))' }}
    />
  );
};
